/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface HistoricalTrack
 */
export interface HistoricalTrack {
    /**
     * Total distance of the track in meters
     * @type {number}
     * @memberof HistoricalTrack
     */
    distance?: number;
    /**
     * 
     * @type {Ship}
     * @memberof HistoricalTrack
     */
    ship: Ship;
    /**
     * 
     * @type {Track}
     * @memberof HistoricalTrack
     */
    track: Track;
}

/**
 * Check if a given object implements the HistoricalTrack interface.
 */
export function instanceOfHistoricalTrack(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ship" in value;
    isInstance = isInstance && "track" in value;

    return isInstance;
}

export function HistoricalTrackFromJSON(json: any): HistoricalTrack {
    return HistoricalTrackFromJSONTyped(json, false);
}

export function HistoricalTrackFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoricalTrack {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'ship': ShipFromJSON(json['ship']),
        'track': TrackFromJSON(json['track']),
    };
}

export function HistoricalTrackToJSON(value?: HistoricalTrack | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distance': value.distance,
        'ship': ShipToJSON(value.ship),
        'track': TrackToJSON(value.track),
    };
}

